import { Column, DictionaryColumn } from '.';

export function isDictionaryColumn(column?: Column): column is DictionaryColumn {
  return column?.type === 'DICTIONARY';
}

export function isDictionaryValue(column: DictionaryColumn, value: unknown): value is number {
  return isDictionaryColumn(column);
}
